import { render, staticRenderFns } from "./AppCollapseItemCustom.vue?vue&type=template&id=2b7a3840&"
import script from "./AppCollapseItemCustom.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItemCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports